const images = [
  `${process.env.PUBLIC_URL || ""}/assets/1.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/2.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/3.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/4.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/5.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/6.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/7.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/8.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/9.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/10.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/11.jpg`,
  `${process.env.PUBLIC_URL || ""}/assets/12.jpg`,
];

const gridOptions = {
  1: { rows: 2, cols: 2 },
  2: { rows: 2, cols: 3 },
  3: { rows: 3, cols: 4 },
  4: { rows: 4, cols: 4 },
};

export { images, gridOptions };
